import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, unref as _unref, mergeProps as _mergeProps } from "vue"

const _hoisted_1 = { class: "aligo-sms" }
const _hoisted_2 = { class: "d-flex align-center" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h2", { class: "sms-title" }, "임금명세서 발송 관리", -1)
const _hoisted_4 = { key: 0 }
const _hoisted_5 = { class: "d-flex justify-space-between align-center mb-4" }
const _hoisted_6 = { class: "selected-info" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", {
      class: "text-center",
      style: {"width":"80px"}
    }, "선택"),
    /*#__PURE__*/_createElementVNode("th", { class: "text-center" }, "이름"),
    /*#__PURE__*/_createElementVNode("th", { class: "text-center" }, "직종"),
    /*#__PURE__*/_createElementVNode("th", { class: "text-center" }, "전화번호"),
    /*#__PURE__*/_createElementVNode("th", { class: "text-center" }, "임금합계"),
    /*#__PURE__*/_createElementVNode("th", { class: "text-center" }, "시설명"),
    /*#__PURE__*/_createElementVNode("th", { class: "text-center" }, "임금 연월")
  ])
], -1)
const _hoisted_8 = { class: "text-center" }
const _hoisted_9 = { class: "text-center employee-name" }
const _hoisted_10 = { class: "text-center" }
const _hoisted_11 = { class: "wage-amount text-center" }
const _hoisted_12 = { class: "text-center" }
const _hoisted_13 = { class: "text-center" }
const _hoisted_14 = { class: "mt-4 text-center" }
const _hoisted_15 = {
  key: 0,
  class: "mb-3"
}
const _hoisted_16 = {
  key: 1,
  class: "no-data"
}
const _hoisted_17 = { class: "d-flex align-center" }
const _hoisted_18 = { class: "d-flex align-center justify-center" }
const _hoisted_19 = { key: 0 }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("thead", null, [
  /*#__PURE__*/_createElementVNode("tr", null, [
    /*#__PURE__*/_createElementVNode("th", { class: "text-center" }, "메시지ID"),
    /*#__PURE__*/_createElementVNode("th", { class: "text-center" }, "발송일시"),
    /*#__PURE__*/_createElementVNode("th", { class: "text-center" }, "발신자"),
    /*#__PURE__*/_createElementVNode("th", { class: "text-center" }, "수신자"),
    /*#__PURE__*/_createElementVNode("th", { class: "text-center" }, "메시지타입"),
    /*#__PURE__*/_createElementVNode("th", { class: "text-center" }, "메시지"),
    /*#__PURE__*/_createElementVNode("th", { class: "text-center" }, "발송건수"),
    /*#__PURE__*/_createElementVNode("th", { class: "text-center" }, "실패건수")
  ])
], -1)
const _hoisted_21 = { class: "text-center font-weight-medium" }
const _hoisted_22 = { class: "text-center" }
const _hoisted_23 = { class: "text-center" }
const _hoisted_24 = { class: "text-center receiver-cell" }
const _hoisted_25 = {
  key: 0,
  class: "receiver-content"
}
const _hoisted_26 = { key: 0 }
const _hoisted_27 = { key: 1 }
const _hoisted_28 = {
  key: 1,
  class: "text-grey-500"
}
const _hoisted_29 = { class: "text-center" }
const _hoisted_30 = { class: "message-cell" }
const _hoisted_31 = { class: "message-tooltip" }
const _hoisted_32 = /*#__PURE__*/_createElementVNode("div", { class: "tooltip-header" }, "메시지 전체 내용", -1)
const _hoisted_33 = { class: "tooltip-message" }
const _hoisted_34 = { class: "text-center" }
const _hoisted_35 = { class: "text-center" }
const _hoisted_36 = { class: "fail-reasons-tooltip" }
const _hoisted_37 = /*#__PURE__*/_createElementVNode("div", { class: "tooltip-header" }, "실패 사유", -1)
const _hoisted_38 = {
  key: 1,
  class: "no-data"
}
const _hoisted_39 = /*#__PURE__*/_createElementVNode("p", { class: "text-h6 text-grey-600" }, "임금명세서 발송내역이 없습니다.", -1)
const _hoisted_40 = {
  key: 2,
  class: "no-data"
}
const _hoisted_41 = /*#__PURE__*/_createElementVNode("p", { class: "text-h6 text-grey-600" }, "발송내역을 조회하고 있습니다...", -1)
const _hoisted_42 = {
  key: 3,
  class: "pa-4"
}
const _hoisted_43 = { class: "text-body-2 text-grey-600" }
const _hoisted_44 = {
  key: 0,
  class: "text-info ml-2"
}
const _hoisted_45 = { class: "d-flex align-center" }
const _hoisted_46 = {
  key: 0,
  class: "no-data"
}
const _hoisted_47 = /*#__PURE__*/_createElementVNode("p", { class: "text-h6 text-grey-600" }, "발송가능건수를 조회하고 있습니다...", -1)
const _hoisted_48 = {
  key: 1,
  class: "remain-cards-container"
}
const _hoisted_49 = { class: "text-h4 font-weight-bold primary--text mb-2" }
const _hoisted_50 = /*#__PURE__*/_createElementVNode("p", { class: "text-h6 text-grey-600 mb-0" }, "SMS 잔여건수", -1)
const _hoisted_51 = { class: "text-h4 font-weight-bold secondary--text mb-2" }
const _hoisted_52 = /*#__PURE__*/_createElementVNode("p", { class: "text-h6 text-grey-600 mb-0" }, "LMS 잔여건수", -1)
const _hoisted_53 = { class: "text-h4 font-weight-bold info--text mb-2" }
const _hoisted_54 = /*#__PURE__*/_createElementVNode("p", { class: "text-h6 text-grey-600 mb-0" }, "MMS 잔여건수", -1)
const _hoisted_55 = {
  key: 2,
  class: "no-data"
}
const _hoisted_56 = /*#__PURE__*/_createElementVNode("p", { class: "text-h6 text-grey-600" }, "발송가능건수 데이터가 없습니다.", -1)

import { ref, reactive, computed } from 'vue';
import { useStore } from 'vuex';
import axios from 'axios';
import '@/assets/styles/components/sms.scss';

// 다이얼로그 모델을 독립적으로 관리
interface SmsHistoryItem {
  mid: string;
  type: string;
  sender: string;
  sms_count: string;
  reserve_state: string;
  msg: string;
  fail_count: number;
  reg_date: string;
  reserve: string;
  receivers?: string[];
  failReasons?: string[];
}

interface RemainInfo {
  SMS_CNT?: number;
  LMS_CNT?: number;
  MMS_CNT?: number;
}

interface Employee {
  empId?: string;
  empName: string;
  empJob: string;
  empPhone?: string;
  phone?: string;
  total?: number;
  sisulName?: string;
  ym?: string;
  [key: string]: any;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'AligoSMS',
  setup(__props, { expose: __expose }) {

const dialogModel = ref(false);
const activeTab = ref('employees');

// 인터페이스 정의
const store = useStore();

// 로컬 날짜를 YYYY-MM-DD 형식으로 변환하는 함수 (UTC 시간대 문제 해결)
const formatLocalDate = (date: Date): string => {
  const year = date.getFullYear();
  const month = String(date.getMonth() + 1).padStart(2, '0');
  const day = String(date.getDate()).padStart(2, '0');
  return `${year}-${month}-${day}`;
};

// wageList 데이터
const wageList = ref<Employee[]>([]);

// 로딩 상태
const remainLoading = ref(false);
const historyLoading = ref(false);
const wageLoading = ref(false);

const selectedEmployees = ref<Employee[]>([]);
const selectAll = ref(false);

// 발송 내역
const smsHistory = ref<SmsHistoryItem[]>([]);
const remainInfo = ref<RemainInfo | null>(null);

// 발송내역 필터 및 페이지네이션
const historyFilter = ref({
  page: 1,
  page_size: 30,
  start_date: (() => {
    const today = new Date();
    const startOfMonth = new Date(today.getFullYear(), today.getMonth(), 1);
    return formatLocalDate(startOfMonth);
  })(),
  limit_day: (() => {
    const today = new Date();
    const endOfMonth = new Date(today.getFullYear(), today.getMonth() + 1, 0);
    return formatLocalDate(endOfMonth);
  })(),
  filterByEmployees: true // 기본값: 직원들만 조회
});

// 현재 표시 중인 연월을 추적하는 변수 추가
const currentDisplayYear = ref(new Date().getFullYear());
const currentDisplayMonth = ref(new Date().getMonth()); // 0-11

// 현재 선택된 날짜 범위 타입을 추적하는 변수 추가
const selectedDateRangeType = ref('thisMonth');

const historyInfo = ref<{
  total_count?: number;
  current_page?: number;
  next_yn?: string;
} | null>(null);

// 전체선택 상태 계산
const isIndeterminate = computed(() => {
  const validEmployees = wageList.value.filter(emp => hasValidPhone(emp));
  return selectedEmployees.value.length > 0 && selectedEmployees.value.length < validEmployees.length;
});

// 직원들의 전화번호 목록 추출
const employeePhoneNumbers = computed(() => {
  if (!wageList.value || wageList.value.length === 0) return [];
  
  return wageList.value
    .map(emp => emp.empPhone || emp.phone)
    .filter((phone): phone is string => phone != null && phone.trim() !== '')
    .map(phone => {
      // 전화번호 정규화 (하이픈 제거)
      return phone.replace(/\D/g, '');
    })
    .filter((phone, index, array) => array.indexOf(phone) === index); // 중복 제거
});

// 전화번호 포맷팅 함수
const formatPhoneNumber = (phone?: string) => {
  if (!phone) return '전화번호 없음';
  // 전화번호 포맷팅 (예: 01012345678 -> 010-1234-5678)
  const cleaned = phone.replace(/\D/g, '');
  if (cleaned.length === 11) {
    return cleaned.replace(/(\d{3})(\d{4})(\d{4})/, '$1-$2-$3');
  } else if (cleaned.length === 10) {
    return cleaned.replace(/(\d{3})(\d{3})(\d{4})/, '$1-$2-$3');
  }
  return phone;
};

// 개별 직원 선택 변경 시 호출
const onEmployeeSelectionChange = () => {
  // 전화번호가 있는 직원 수 기준으로 전체선택 상태 업데이트
  const validEmployees = wageList.value.filter(emp => hasValidPhone(emp));
  if (selectedEmployees.value.length === validEmployees.length) {
    selectAll.value = true;
  } else {
    selectAll.value = false;
  }
};

// 다이얼로그 열기 (외부에서 호출)
const openDialog = (wage?: Employee[]) => {
  if (wage && wage.length > 0) {
    wageList.value = wage;
  }
  
  // 현재 날짜를 기준으로 초기화
  const today = new Date();
  currentDisplayYear.value = today.getFullYear();
  currentDisplayMonth.value = today.getMonth();
  
  // 이번 달의 첫째 날과 마지막 날로 설정
  const startOfMonth = new Date(today.getFullYear(), today.getMonth(), 1);
  const endOfMonth = new Date(today.getFullYear(), today.getMonth() + 1, 0);
  
  historyFilter.value.start_date = formatLocalDate(startOfMonth);
  historyFilter.value.limit_day = formatLocalDate(endOfMonth);
  historyFilter.value.page = 1; // 페이지도 초기화
  
  // 날짜 범위 타입을 이번 달로 초기화
  selectedDateRangeType.value = 'thisMonth';
  dialogModel.value = true;
  // 첫 번째 탭으로 이동
  activeTab.value = 'employees';
  
  // 다이얼로그 열릴 때 자동으로 발송내역과 발송가능건수 조회
  setTimeout(() => {
    getSmsHistory();
    getSmsRemain();
  }, 100);
};

// 다이얼로그 닫기
const closeDialog = () => {
  dialogModel.value = false;
  // 상태 초기화
  selectedEmployees.value = [];
  selectAll.value = false;
  activeTab.value = 'employees';
  
  // 날짜 관련 상태도 초기화
  const today = new Date();
  currentDisplayYear.value = today.getFullYear();
  currentDisplayMonth.value = today.getMonth();
  selectedDateRangeType.value = 'thisMonth';
  
  // 히스토리 필터 초기화
  historyFilter.value.page = 1;
  smsHistory.value = [];
  historyInfo.value = null;
  remainInfo.value = null;
};

// 날짜시간 포맷팅 함수
const formatDateTime = (dateStr: string) => {
  if (!dateStr) return '-';
  // YYYY-MM-DD HH:mm:ss 형식으로 변환
  if (dateStr.length === 14) {
    // YYYYMMDDHHMMSS -> YYYY-MM-DD HH:mm:ss
    return `${dateStr.substr(0,4)}-${dateStr.substr(4,2)}-${dateStr.substr(6,2)} ${dateStr.substr(8,2)}:${dateStr.substr(10,2)}:${dateStr.substr(12,2)}`;
  }
  return dateStr;
};

// SMS 상세 정보 표시
const showSmsDetail = (item: SmsHistoryItem) => {
  store.commit('showSnackbar', {
    text: `메시지 ID: ${item.mid}\n발송타입: ${item.type}\n발송건수: ${item.sms_count}건\n실패건수: ${item.fail_count}건\n메시지: ${item.msg}`,
    color: 'info'
  });
  
  // 실제 상세 조회 API 호출
  getSmsDetail(item.mid);
};

// 메시지 타입 색상 반환 함수
const getTypeColor = (type: string) => {
  switch (type) {
    case 'SMS':
      return 'primary';
    case 'LMS':
      return 'secondary';
    case 'MMS':
      return 'info';
    default:
      return 'grey';
  }
};

// 상태 색상 반환 함수
const getStatusColor = (status: string) => {
  switch (status) {
    case '성공':
    case 'SUCCESS':
      return 'success';
    case '실패':
    case 'FAILED':
      return 'error';
    case '대기':
    case 'PENDING':
      return 'warning';
    default:
      return 'grey';
  }
};

// 전체 선택/해제
const toggleSelectAll = () => {
  if (selectAll.value) {
    // 전화번호가 있는 직원만 선택
    selectedEmployees.value = wageList.value.filter(emp => hasValidPhone(emp));
  } else {
    selectedEmployees.value = [];
  }
};

// 임금명세서 기반 SMS 발송
const sendWageSms = async () => {
  if (selectedEmployees.value.length === 0) {
    store.commit('showSnackbar', {
      text: '발송할 직원을 선택해주세요.',
      color: 'error'
    });
    return;
  }

  // 전화번호가 없는 직원 확인
  const employeesWithoutPhone = selectedEmployees.value.filter(emp => !emp.empPhone && !emp.phone);
  if (employeesWithoutPhone.length > 0) {
    store.commit('showSnackbar', {
      text: `전화번호가 없는 직원이 ${employeesWithoutPhone.length}명 있습니다. 확인해주세요.`,
      color: 'warning'
    });
  }

  wageLoading.value = true;
  try {
    const requestData = {
      employees: selectedEmployees.value,
      sisulName: store.getters.AdminSisulName,
      sisulCode: store.getters.AdminSisulCode
    };
    
    const response = await axios.post('/api/sms/send-wage', requestData);
    
    if (response.data.code === '1') {
      const { successCount, failCount, totalCount } = response.data.data;
      store.commit('showSnackbar', {
        text: `임금명세서 발송 완료 - 성공: ${successCount}건, 실패: ${failCount}건`,
        color: 'success'
      });
      
      // 선택 초기화
      selectedEmployees.value = [];
      selectAll.value = false;
      
      // 발송 내역 탭으로 이동하고 새로고침
      activeTab.value = 'history';
      getSmsHistory();
    } else {
      store.commit('showSnackbar', {
        text: response.data.message || '임금명세서 발송에 실패했습니다.',
        color: 'error'
      });
    }
  } catch (error) {
    console.error('임금명세서 발송 오류:', error);
    console.error('에러 응답:', (error as any).response?.data);
    store.commit('showSnackbar', {
      text: '임금명세서 발송 중 오류가 발생했습니다.',
      color: 'error'
    });
  } finally {
    wageLoading.value = false;
  }
};

// 페이지 변경 함수
const changePage = (page: number) => {
  historyFilter.value.page = page;
  getSmsHistory();
};

// 발송 내역 조회
const getSmsHistory = async () => {
  historyLoading.value = true;
  try {
    // 날짜 형식 변환 (YYYY-MM-DD -> YYYYMMDD)
    const formatDate = (dateStr: string) => {
      if (!dateStr) return '';
      return dateStr.replace(/-/g, '');
    };

    const params = {
      page: historyFilter.value.page,
      page_size: historyFilter.value.page_size,
      ...(historyFilter.value.start_date && { start_date: formatDate(historyFilter.value.start_date) }),
      ...(historyFilter.value.limit_day && { limit_day: formatDate(historyFilter.value.limit_day) })
    };


    const response = await axios.get('/api/sms/history', { params });
    
    
    // Aligo API 응답 구조에 맞게 수정
    if (response.data.result_code === 1) {
      const historyList = response.data.list || [];
      
      // 모든 메시지의 상세정보를 병렬로 조회
      if (historyList.length > 0) {
        
        const detailPromises = historyList.map(async (item: SmsHistoryItem) => {
          try {
            const detailResponse = await axios.get(`/api/sms/detail/${item.mid}`);
            if (detailResponse.data.list && detailResponse.data.list.length > 0) {
              // 수신자 목록 추출
              const receivers = detailResponse.data.list.map((detail: any) => detail.receiver || detail.phone);
              
              // 실패 사유 추출 (sms_state가 성공이 아닌 경우들)
              const failReasons = detailResponse.data.list
                .filter((detail: any) => detail.sms_state && detail.sms_state !== '전송성공' && detail.sms_state !== '성공')
                .map((detail: any) => detail.sms_state)
                .filter((reason: string, index: number, array: string[]) => array.indexOf(reason) === index); // 중복 제거
              
              return { 
                ...item, 
                receivers: receivers.filter(Boolean),
                failReasons: failReasons
              };
            }
            return { ...item, receivers: [], failReasons: [] };
          } catch (error) {
            console.error(`메시지 ${item.mid} 상세조회 오류:`, error);
            return { ...item, receivers: [], failReasons: [] };
          }
        });
        
        // 모든 상세조회 완료 대기
        const enrichedHistory = await Promise.all(detailPromises);
        
        // 직원 필터링 적용
        if (historyFilter.value.filterByEmployees && employeePhoneNumbers.value.length > 0) {
          const filteredHistory = enrichedHistory.filter(item => {
            if (!item.receivers || item.receivers.length === 0) return false;
            
            // 수신자 중 직원 전화번호가 포함되어 있는지 확인
            return item.receivers.some((receiver: string) => {
              const normalizedReceiver = receiver.replace(/\D/g, '');
              return employeePhoneNumbers.value.includes(normalizedReceiver);
            });
          });
          smsHistory.value = filteredHistory;
        } else {
          smsHistory.value = enrichedHistory;
        }
        
      } else {
        smsHistory.value = historyList;
      }
      
      historyInfo.value = {
        total_count: historyList.length,
        current_page: historyFilter.value.page,
        next_yn: response.data.next_yn || 'N'
      };
      
      store.commit('showSnackbar', {
        text: `발송 내역을 조회했습니다. (총 ${historyInfo.value.total_count}건)`,
        color: 'info'
      });
    } else {
      smsHistory.value = [];
      historyInfo.value = null;
      store.commit('showSnackbar', {
        text: response.data.message || '발송 내역 조회에 실패했습니다.',
        color: 'error'
      });
    }
  } catch (error) {
    console.error('발송 내역 조회 오류:', error);
    smsHistory.value = [];
    historyInfo.value = null;
    store.commit('showSnackbar', {
      text: '발송 내역 조회 중 오류가 발생했습니다.',
      color: 'error'
    });
  } finally {
    historyLoading.value = false;
  }
};

// 발송 가능 건수 조회
const getSmsRemain = async () => {
  remainLoading.value = true;
  try {
    
    const response = await axios.get('/api/sms/remain');
    
    
    // Aligo API 응답 구조 확인 후 처리
    if (response.data.result_code === 1 || response.data.code === '1') {
      // 응답 데이터 구조에 따라 처리
      remainInfo.value = {
        SMS_CNT: response.data.SMS_CNT || response.data.sms_count || 0,
        LMS_CNT: response.data.LMS_CNT || response.data.lms_count || 0,
        MMS_CNT: response.data.MMS_CNT || response.data.mms_count || 0
      };
      
      
      store.commit('showSnackbar', {
        text: '발송 가능 건수를 조회했습니다.',
        color: 'info'
      });
    } else {
      // 응답이 실패한 경우에도 테스트용 데이터 표시
      remainInfo.value = {
        SMS_CNT: 100,
        LMS_CNT: 50,
        MMS_CNT: 25
      };
      
      store.commit('showSnackbar', {
        text: response.data.message || '발송 가능 건수 조회에 실패했습니다. (테스트 데이터 표시)',
        color: 'warning'
      });
    }
  } catch (error) {
    console.error('발송 가능 건수 조회 오류:', error);
    console.error('에러 상세:', (error as any).response?.data);
    
    // 오류 시에도 테스트용 데이터 표시
    remainInfo.value = {
      SMS_CNT: 100,
      LMS_CNT: 50,
      MMS_CNT: 25
    };
    
    store.commit('showSnackbar', {
      text: '발송 가능 건수 조회 중 오류가 발생했습니다. (테스트 데이터 표시)',
      color: 'warning'
    });
  } finally {
    remainLoading.value = false;
  }
};

// SMS 상세 조회
const getSmsDetail = async (mid: string) => {
  try {
    const response = await axios.get(`/api/sms/detail/${mid}`);
    if (response.data.list) {
      store.commit('showSnackbar', {
        text: '상세 정보를 조회했습니다.',
        color: 'info'
      });
      // 여기서 상세 정보를 다이얼로그로 표시할 수 있습니다.
    } else {
      store.commit('showSnackbar', {
        text: '상세 정보 조회에 실패했습니다.',
        color: 'error'
      });
    }
  } catch (error) {
    console.error('SMS 상세 조회 오류:', error);
    store.commit('showSnackbar', {
      text: '상세 정보 조회 중 오류가 발생했습니다.',
      color: 'error'
    });
  }
};

// 외부에서 호출할 수 있도록 expose
__expose({
  openDialog
});

// 날짜 관련 함수들
const formatDateRange = () => {
  return `${currentDisplayYear.value}-${String(currentDisplayMonth.value + 1).padStart(2, '0')}`;
};

// 한 달 단위로 날짜 범위 변경
const changeDateRange = (monthOffset: number) => {
  // 현재 표시 중인 연월을 기준으로 이동
  const newMonth = currentDisplayMonth.value + monthOffset;
  const newYear = currentDisplayYear.value + Math.floor(newMonth / 12);
  const adjustedMonth = ((newMonth % 12) + 12) % 12;
  
  // 현재 표시 연월 업데이트
  currentDisplayYear.value = newYear;
  currentDisplayMonth.value = adjustedMonth;
  
  // 해당 월의 첫째 날과 마지막 날 계산
  const startOfMonth = new Date(newYear, adjustedMonth, 1);
  const endOfMonth = new Date(newYear, adjustedMonth + 1, 0);
  
  // 날짜 필터 업데이트
  historyFilter.value.start_date = formatLocalDate(startOfMonth);
  historyFilter.value.limit_day = formatLocalDate(endOfMonth);
  
  // 날짜 범위 타입 초기화 (수동으로 변경했으므로)
  selectedDateRangeType.value = '';
  
  // 자동으로 조회
  getSmsHistory();
};

// 빠른 날짜 설정
const setDateRange = (type: string) => {
  const today = new Date();
  let startDate: Date;
  let endDate: Date;
  let targetYear: number;
  let targetMonth: number;
  
  // 선택된 날짜 범위 타입 업데이트
  selectedDateRangeType.value = type;
  
  switch (type) {
    case 'today':
      startDate = new Date(today.getFullYear(), today.getMonth(), today.getDate());
      endDate = new Date(today.getFullYear(), today.getMonth(), today.getDate());
      targetYear = today.getFullYear();
      targetMonth = today.getMonth();
      break;
      
    case 'thisMonth':
      startDate = new Date(today.getFullYear(), today.getMonth(), 1);
      endDate = new Date(today.getFullYear(), today.getMonth() + 1, 0);
      targetYear = today.getFullYear();
      targetMonth = today.getMonth();
      break;
      
    case 'lastMonth':
      const lastMonth = today.getMonth() - 1;
      const lastMonthYear = lastMonth < 0 ? today.getFullYear() - 1 : today.getFullYear();
      const adjustedLastMonth = lastMonth < 0 ? 11 : lastMonth;
      
      startDate = new Date(lastMonthYear, adjustedLastMonth, 1);
      endDate = new Date(lastMonthYear, adjustedLastMonth + 1, 0);
      targetYear = lastMonthYear;
      targetMonth = adjustedLastMonth;
      break;
      
    case 'last3Months':
      const threeMonthsAgo = today.getMonth() - 2;
      const threeMonthsAgoYear = threeMonthsAgo < 0 ? today.getFullYear() - 1 : today.getFullYear();
      const adjustedThreeMonthsAgo = threeMonthsAgo < 0 ? 12 + threeMonthsAgo : threeMonthsAgo;
      
      startDate = new Date(threeMonthsAgoYear, adjustedThreeMonthsAgo, 1);
      endDate = new Date(today.getFullYear(), today.getMonth() + 1, 0);
      targetYear = threeMonthsAgoYear;
      targetMonth = adjustedThreeMonthsAgo;
      break;
      
    default:
      return;
  }
  
  // 현재 표시 연월 업데이트
  currentDisplayYear.value = targetYear;
  currentDisplayMonth.value = targetMonth;
  
  // 날짜 필터 업데이트
  historyFilter.value.start_date = formatLocalDate(startDate);
  historyFilter.value.limit_day = formatLocalDate(endDate);

  // 자동으로 조회
  getSmsHistory();
};

// 현재 월인지 확인
const isCurrentMonth = () => {
  const today = new Date();
  return today.getFullYear() === currentDisplayYear.value && 
         today.getMonth() === currentDisplayMonth.value;
};

// 날짜 입력 필드가 변경될 때 현재 표시 연월도 업데이트
const onDateInputChange = () => {
  if (historyFilter.value.start_date) {
    const startDate = new Date(historyFilter.value.start_date + 'T00:00:00'); // 로컬 시간으로 파싱
    currentDisplayYear.value = startDate.getFullYear();
    currentDisplayMonth.value = startDate.getMonth();
    
    // 시작일이 변경되면 해당 월의 마지막 날로 마감일 자동 설정
    const endOfMonth = new Date(startDate.getFullYear(), startDate.getMonth() + 1, 0);
    historyFilter.value.limit_day = formatLocalDate(endOfMonth);
    
    // 날짜 범위 타입 초기화 (수동으로 변경했으므로)
    selectedDateRangeType.value = '';

  }
};

// 전화번호가 있는지 확인하는 함수
const hasValidPhone = (employee: Employee) => {
  return employee.empPhone || employee.phone;
};

return (_ctx: any,_cache: any) => {
  const _component_v_icon = _resolveComponent("v-icon")!
  const _component_v_chip = _resolveComponent("v-chip")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_card_title = _resolveComponent("v-card-title")!
  const _component_v_divider = _resolveComponent("v-divider")!
  const _component_v_tab = _resolveComponent("v-tab")!
  const _component_v_tabs = _resolveComponent("v-tabs")!
  const _component_v_checkbox = _resolveComponent("v-checkbox")!
  const _component_v_table = _resolveComponent("v-table")!
  const _component_v_alert = _resolveComponent("v-alert")!
  const _component_v_card_text = _resolveComponent("v-card-text")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_window_item = _resolveComponent("v-window-item")!
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_btn_group = _resolveComponent("v-btn-group")!
  const _component_v_text_field = _resolveComponent("v-text-field")!
  const _component_v_select = _resolveComponent("v-select")!
  const _component_v_tooltip = _resolveComponent("v-tooltip")!
  const _component_v_progress_circular = _resolveComponent("v-progress-circular")!
  const _component_v_window = _resolveComponent("v-window")!
  const _component_v_dialog = _resolveComponent("v-dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createVNode(_component_v_dialog, {
      modelValue: dialogModel.value,
      "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => ((dialogModel).value = $event)),
      "max-width": "1400px",
      height: "800px",
      persistent: "",
      scrollable: ""
    }, {
      default: _withCtx(() => [
        _createVNode(_component_v_card, { class: "rounded-lg" }, {
          default: _withCtx(() => [
            _createVNode(_component_v_card_title, { class: "d-flex justify-space-between align-center pa-4" }, {
              default: _withCtx(() => [
                _createElementVNode("div", _hoisted_2, [
                  _createVNode(_component_v_icon, {
                    color: "primary",
                    class: "mr-2"
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("mdi-send")
                    ]),
                    _: 1
                  }),
                  _hoisted_3,
                  (wageList.value && wageList.value.length > 0)
                    ? (_openBlock(), _createBlock(_component_v_chip, {
                        key: 0,
                        color: "info",
                        class: "ml-3"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(" 임금대장 " + _toDisplayString(wageList.value.length) + "명 로드됨 ", 1)
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ]),
                _createVNode(_component_v_btn, {
                  icon: "",
                  onClick: closeDialog,
                  class: "btnColorError"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_icon, null, {
                      default: _withCtx(() => [
                        _createTextVNode("mdi-close")
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_v_divider),
            _createVNode(_component_v_card_text, { class: "pa-4" }, {
              default: _withCtx(() => [
                _createVNode(_component_v_tabs, {
                  modelValue: activeTab.value,
                  "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((activeTab).value = $event)),
                  class: "mb-4"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_tab, { value: "employees" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_icon, { class: "mr-2" }, {
                          default: _withCtx(() => [
                            _createTextVNode("mdi-account-multiple")
                          ]),
                          _: 1
                        }),
                        _createTextVNode(" 발송대상 직원 ")
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_tab, { value: "history" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_icon, { class: "mr-2" }, {
                          default: _withCtx(() => [
                            _createTextVNode("mdi-history")
                          ]),
                          _: 1
                        }),
                        _createTextVNode(" 발송내역 조회 ")
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_tab, { value: "remain" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_icon, { class: "mr-2" }, {
                          default: _withCtx(() => [
                            _createTextVNode("mdi-counter")
                          ]),
                          _: 1
                        }),
                        _createTextVNode(" 발송가능건수 확인 ")
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue"]),
                _createVNode(_component_v_window, {
                  modelValue: activeTab.value,
                  "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => ((activeTab).value = $event))
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_v_window_item, { value: "employees" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_card, { elevation: "2" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_card_title, { class: "bg-success text-white" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_icon, { class: "mr-2" }, {
                                  default: _withCtx(() => [
                                    _createTextVNode("mdi-account-cash")
                                  ]),
                                  _: 1
                                }),
                                _createTextVNode(" 임금명세서 발송대상 직원 (" + _toDisplayString(wageList.value.length) + "명) ", 1)
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_v_card_text, { class: "pa-4" }, {
                              default: _withCtx(() => [
                                (wageList.value && wageList.value.length > 0)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                                      _createElementVNode("div", _hoisted_5, [
                                        _createVNode(_component_v_checkbox, {
                                          modelValue: selectAll.value,
                                          "onUpdate:modelValue": [
                                            _cache[1] || (_cache[1] = ($event: any) => ((selectAll).value = $event)),
                                            toggleSelectAll
                                          ],
                                          indeterminate: isIndeterminate.value,
                                          label: "전체 선택",
                                          density: "compact",
                                          class: "mb-0"
                                        }, null, 8, ["modelValue", "indeterminate"]),
                                        _createElementVNode("div", _hoisted_6, " 선택된 직원: " + _toDisplayString(selectedEmployees.value.length) + "명 / 발송가능: " + _toDisplayString(wageList.value.filter(emp => hasValidPhone(emp)).length) + "명 ", 1)
                                      ]),
                                      _createVNode(_component_v_table, {
                                        class: "employee-data-table",
                                        density: "compact"
                                      }, {
                                        default: _withCtx(() => [
                                          _hoisted_7,
                                          _createElementVNode("tbody", null, [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(wageList.value, (employee) => {
                                              return (_openBlock(), _createElementBlock("tr", {
                                                key: employee.empId || employee.empName
                                              }, [
                                                _createElementVNode("td", _hoisted_8, [
                                                  _createVNode(_component_v_checkbox, {
                                                    modelValue: selectedEmployees.value,
                                                    "onUpdate:modelValue": [
                                                      _cache[2] || (_cache[2] = ($event: any) => ((selectedEmployees).value = $event)),
                                                      onEmployeeSelectionChange
                                                    ],
                                                    value: employee,
                                                    disabled: !hasValidPhone(employee),
                                                    density: "compact",
                                                    class: "ma-0"
                                                  }, null, 8, ["modelValue", "value", "disabled"])
                                                ]),
                                                _createElementVNode("td", _hoisted_9, _toDisplayString(employee.empName), 1),
                                                _createElementVNode("td", _hoisted_10, _toDisplayString(employee.empJob), 1),
                                                _createElementVNode("td", {
                                                  class: _normalizeClass(["text-center", { 'text-error': !hasValidPhone(employee) }])
                                                }, _toDisplayString(formatPhoneNumber(employee.empPhone || employee.phone)), 3),
                                                _createElementVNode("td", _hoisted_11, _toDisplayString((employee.total || 0).toLocaleString()) + "원", 1),
                                                _createElementVNode("td", _hoisted_12, _toDisplayString(employee.sisulName || '-'), 1),
                                                _createElementVNode("td", _hoisted_13, _toDisplayString(_unref(store).state.AdminYYMM || '-'), 1)
                                              ]))
                                            }), 128))
                                          ])
                                        ]),
                                        _: 1
                                      }),
                                      _createElementVNode("div", _hoisted_14, [
                                        (wageList.value.filter(emp => !hasValidPhone(emp)).length > 0)
                                          ? (_openBlock(), _createElementBlock("div", _hoisted_15, [
                                              _createVNode(_component_v_alert, {
                                                type: "warning",
                                                variant: "outlined",
                                                density: "compact",
                                                class: "text-left"
                                              }, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_v_icon, { class: "mr-2" }, {
                                                    default: _withCtx(() => [
                                                      _createTextVNode("mdi-alert")
                                                    ]),
                                                    _: 1
                                                  }),
                                                  _createTextVNode(" 전화번호가 없는 직원 " + _toDisplayString(wageList.value.filter(emp => !hasValidPhone(emp)).length) + "명은 발송 대상에서 제외됩니다. ", 1)
                                                ]),
                                                _: 1
                                              })
                                            ]))
                                          : _createCommentVNode("", true),
                                        _createVNode(_component_v_btn, {
                                          class: "btnColorSuccess",
                                          size: "large",
                                          loading: wageLoading.value,
                                          disabled: selectedEmployees.value.length === 0,
                                          onClick: sendWageSms
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_v_icon, { class: "mr-2" }, {
                                              default: _withCtx(() => [
                                                _createTextVNode("mdi-send")
                                              ]),
                                              _: 1
                                            }),
                                            _createTextVNode(" 임금명세서 발송 (" + _toDisplayString(selectedEmployees.value.length) + "명) ", 1)
                                          ]),
                                          _: 1
                                        }, 8, ["loading", "disabled"])
                                      ])
                                    ]))
                                  : (_openBlock(), _createElementBlock("div", _hoisted_16, " 임금대장 데이터가 없습니다. "))
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_window_item, { value: "history" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_card, { elevation: "2" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_card_title, { class: "bg-info text-white d-flex justify-space-between align-center" }, {
                              default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_17, [
                                  _createVNode(_component_v_icon, { class: "mr-2" }, {
                                    default: _withCtx(() => [
                                      _createTextVNode("mdi-history")
                                    ]),
                                    _: 1
                                  }),
                                  _createTextVNode(" 임금명세서 발송내역 ")
                                ]),
                                _createVNode(_component_v_btn, {
                                  class: "btnColorPrimary",
                                  onClick: getSmsHistory,
                                  loading: historyLoading.value
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_icon, { class: "mr-1" }, {
                                      default: _withCtx(() => [
                                        _createTextVNode("mdi-refresh")
                                      ]),
                                      _: 1
                                    }),
                                    _createTextVNode(" 새로고침 ")
                                  ]),
                                  _: 1
                                }, 8, ["loading"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_v_card_text, { class: "pa-4" }, {
                              default: _withCtx(() => [
                                _createVNode(_component_v_row, {
                                  class: "mb-3",
                                  style: {"display":"none"}
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_col, { cols: "12" }, {
                                      default: _withCtx(() => [
                                        _createElementVNode("div", _hoisted_18, [
                                          _createVNode(_component_v_btn, {
                                            icon: "",
                                            size: "small",
                                            class: "btnColorPrimary mr-2",
                                            onClick: _cache[3] || (_cache[3] = ($event: any) => (changeDateRange(-1)))
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_v_icon, null, {
                                                default: _withCtx(() => [
                                                  _createTextVNode("mdi-chevron-left")
                                                ]),
                                                _: 1
                                              })
                                            ]),
                                            _: 1
                                          }),
                                          _createVNode(_component_v_chip, {
                                            color: "primary",
                                            variant: "elevated",
                                            size: "large",
                                            class: "mx-4 px-4"
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_v_icon, { class: "mr-2" }, {
                                                default: _withCtx(() => [
                                                  _createTextVNode("mdi-calendar")
                                                ]),
                                                _: 1
                                              }),
                                              _createTextVNode(" " + _toDisplayString(formatDateRange()), 1)
                                            ]),
                                            _: 1
                                          }),
                                          _createVNode(_component_v_btn, {
                                            icon: "",
                                            size: "small",
                                            class: "btnColorPrimary ml-2",
                                            onClick: _cache[4] || (_cache[4] = ($event: any) => (changeDateRange(1)))
                                          }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_v_icon, null, {
                                                default: _withCtx(() => [
                                                  _createTextVNode("mdi-chevron-right")
                                                ]),
                                                _: 1
                                              })
                                            ]),
                                            _: 1
                                          })
                                        ])
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_v_row, { class: "mb-3" }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_col, {
                                      cols: "12",
                                      class: "text-center"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_btn_group, {
                                          density: "compact",
                                          variant: "outlined"
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_v_btn, {
                                              size: "small",
                                              onClick: _cache[5] || (_cache[5] = ($event: any) => (setDateRange('thisMonth'))),
                                              color: selectedDateRangeType.value === 'thisMonth' ? 'primary' : 'default'
                                            }, {
                                              default: _withCtx(() => [
                                                _createTextVNode(" 이번 달 ")
                                              ]),
                                              _: 1
                                            }, 8, ["color"]),
                                            _createVNode(_component_v_btn, {
                                              size: "small",
                                              onClick: _cache[6] || (_cache[6] = ($event: any) => (setDateRange('lastMonth'))),
                                              color: selectedDateRangeType.value === 'lastMonth' ? 'primary' : 'default'
                                            }, {
                                              default: _withCtx(() => [
                                                _createTextVNode(" 지난 달 ")
                                              ]),
                                              _: 1
                                            }, 8, ["color"]),
                                            _createVNode(_component_v_btn, {
                                              size: "small",
                                              onClick: _cache[7] || (_cache[7] = ($event: any) => (setDateRange('last3Months'))),
                                              color: selectedDateRangeType.value === 'last3Months' ? 'primary' : 'default'
                                            }, {
                                              default: _withCtx(() => [
                                                _createTextVNode(" 최근 3개월 ")
                                              ]),
                                              _: 1
                                            }, 8, ["color"]),
                                            _createVNode(_component_v_btn, {
                                              size: "small",
                                              onClick: _cache[8] || (_cache[8] = ($event: any) => (setDateRange('today'))),
                                              color: selectedDateRangeType.value === 'today' ? 'primary' : 'default'
                                            }, {
                                              default: _withCtx(() => [
                                                _createTextVNode(" 오늘 ")
                                              ]),
                                              _: 1
                                            }, 8, ["color"])
                                          ]),
                                          _: 1
                                        })
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                }),
                                _createVNode(_component_v_row, null, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_col, {
                                      cols: "12",
                                      md: "3"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_text_field, {
                                          modelValue: historyFilter.value.start_date,
                                          "onUpdate:modelValue": [
                                            _cache[9] || (_cache[9] = ($event: any) => ((historyFilter.value.start_date) = $event)),
                                            onDateInputChange
                                          ],
                                          label: "조회시작일자",
                                          type: "date",
                                          density: "compact",
                                          variant: "outlined"
                                        }, null, 8, ["modelValue"])
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_v_col, {
                                      cols: "12",
                                      md: "3"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_text_field, {
                                          modelValue: historyFilter.value.limit_day,
                                          "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((historyFilter.value.limit_day) = $event)),
                                          label: "조회마감일자",
                                          type: "date",
                                          density: "compact",
                                          variant: "outlined"
                                        }, null, 8, ["modelValue"])
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_v_col, {
                                      cols: "12",
                                      md: "2"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_select, {
                                          modelValue: historyFilter.value.filterByEmployees,
                                          "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((historyFilter.value.filterByEmployees) = $event)),
                                          items: [
                          { title: '직원들만 조회', value: true },
                          { title: '전체 조회', value: false }
                        ],
                                          label: "조회 범위",
                                          density: "compact",
                                          variant: "outlined"
                                        }, null, 8, ["modelValue"])
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_v_col, {
                                      cols: "12",
                                      md: "2"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_select, {
                                          modelValue: historyFilter.value.page_size,
                                          "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((historyFilter.value.page_size) = $event)),
                                          items: [10, 30, 50, 100],
                                          label: "페이지당 건수",
                                          density: "compact",
                                          variant: "outlined"
                                        }, null, 8, ["modelValue"])
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_v_col, {
                                      cols: "12",
                                      md: "1"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_text_field, {
                                          modelValue: historyFilter.value.page,
                                          "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((historyFilter.value.page) = $event)),
                                          label: "페이지",
                                          type: "number",
                                          min: "1",
                                          density: "compact",
                                          variant: "outlined"
                                        }, null, 8, ["modelValue"])
                                      ]),
                                      _: 1
                                    }),
                                    _createVNode(_component_v_col, {
                                      cols: "12",
                                      md: "1"
                                    }, {
                                      default: _withCtx(() => [
                                        _createVNode(_component_v_btn, {
                                          class: "btnColorSuccess",
                                          onClick: getSmsHistory,
                                          loading: historyLoading.value,
                                          block: ""
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_v_icon, { class: "mr-1" }, {
                                              default: _withCtx(() => [
                                                _createTextVNode("mdi-magnify")
                                              ]),
                                              _: 1
                                            }),
                                            _createTextVNode(" 조회 ")
                                          ]),
                                          _: 1
                                        }, 8, ["loading"])
                                      ]),
                                      _: 1
                                    })
                                  ]),
                                  _: 1
                                })
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_v_card_text, { class: "pa-0" }, {
                              default: _withCtx(() => [
                                (smsHistory.value.length > 0)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                                      _createVNode(_component_v_table, {
                                        class: "history-data-table",
                                        density: "compact"
                                      }, {
                                        default: _withCtx(() => [
                                          _hoisted_20,
                                          _createElementVNode("tbody", null, [
                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(smsHistory.value, (item) => {
                                              return (_openBlock(), _createElementBlock("tr", {
                                                key: item.mid
                                              }, [
                                                _createElementVNode("td", _hoisted_21, _toDisplayString(item.mid), 1),
                                                _createElementVNode("td", _hoisted_22, _toDisplayString(formatDateTime(item.reg_date)), 1),
                                                _createElementVNode("td", _hoisted_23, _toDisplayString(item.sender), 1),
                                                _createElementVNode("td", _hoisted_24, [
                                                  (item.receivers && item.receivers.length > 0)
                                                    ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                                                        (item.receivers.length <= 3)
                                                          ? (_openBlock(), _createElementBlock("span", _hoisted_26, _toDisplayString(item.receivers.join(', ')), 1))
                                                          : (_openBlock(), _createElementBlock("span", _hoisted_27, _toDisplayString(item.receivers.slice(0, 2).join(', ')) + " 외 " + _toDisplayString(item.receivers.length - 2) + "명 ", 1))
                                                      ]))
                                                    : (_openBlock(), _createElementBlock("div", _hoisted_28, "-"))
                                                ]),
                                                _createElementVNode("td", _hoisted_29, [
                                                  _createVNode(_component_v_chip, {
                                                    color: getTypeColor(item.type),
                                                    size: "small",
                                                    variant: "flat",
                                                    class: "font-weight-bold"
                                                  }, {
                                                    default: _withCtx(() => [
                                                      _createTextVNode(_toDisplayString(item.type), 1)
                                                    ]),
                                                    _: 2
                                                  }, 1032, ["color"])
                                                ]),
                                                _createElementVNode("td", _hoisted_30, [
                                                  _createVNode(_component_v_tooltip, {
                                                    location: "top",
                                                    "max-width": "400px"
                                                  }, {
                                                    activator: _withCtx(({ props }) => [
                                                      _createElementVNode("div", _mergeProps(props, {
                                                        class: "message-content",
                                                        style: {"cursor":"help"}
                                                      }), _toDisplayString(item.msg && item.msg.length > 30 ? item.msg.substring(0, 30) + '...' : item.msg), 17)
                                                    ]),
                                                    default: _withCtx(() => [
                                                      _createElementVNode("div", _hoisted_31, [
                                                        _hoisted_32,
                                                        _createElementVNode("div", _hoisted_33, _toDisplayString(item.msg), 1)
                                                      ])
                                                    ]),
                                                    _: 2
                                                  }, 1024)
                                                ]),
                                                _createElementVNode("td", _hoisted_34, [
                                                  _createVNode(_component_v_chip, {
                                                    color: "info",
                                                    size: "small",
                                                    variant: "outlined"
                                                  }, {
                                                    default: _withCtx(() => [
                                                      _createTextVNode(_toDisplayString(item.sms_count) + "건 ", 1)
                                                    ]),
                                                    _: 2
                                                  }, 1024)
                                                ]),
                                                _createElementVNode("td", _hoisted_35, [
                                                  (item.fail_count > 0 && item.failReasons && item.failReasons.length > 0)
                                                    ? (_openBlock(), _createBlock(_component_v_tooltip, {
                                                        key: 0,
                                                        location: "top",
                                                        "max-width": "300px"
                                                      }, {
                                                        activator: _withCtx(({ props }) => [
                                                          _createVNode(_component_v_chip, _mergeProps(props, {
                                                            color: item.fail_count > 0 ? 'error' : 'success',
                                                            size: "small",
                                                            variant: "flat",
                                                            style: {"cursor":"help"}
                                                          }), {
                                                            default: _withCtx(() => [
                                                              _createTextVNode(_toDisplayString(item.fail_count) + "건 ", 1)
                                                            ]),
                                                            _: 2
                                                          }, 1040, ["color"])
                                                        ]),
                                                        default: _withCtx(() => [
                                                          _createElementVNode("div", _hoisted_36, [
                                                            _hoisted_37,
                                                            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(item.failReasons, (reason, index) => {
                                                              return (_openBlock(), _createElementBlock("div", {
                                                                key: index,
                                                                class: "tooltip-item"
                                                              }, " • " + _toDisplayString(reason), 1))
                                                            }), 128))
                                                          ])
                                                        ]),
                                                        _: 2
                                                      }, 1024))
                                                    : (_openBlock(), _createBlock(_component_v_chip, {
                                                        key: 1,
                                                        color: item.fail_count > 0 ? 'error' : 'success',
                                                        size: "small",
                                                        variant: "flat"
                                                      }, {
                                                        default: _withCtx(() => [
                                                          _createTextVNode(_toDisplayString(item.fail_count) + "건 ", 1)
                                                        ]),
                                                        _: 2
                                                      }, 1032, ["color"]))
                                                ])
                                              ]))
                                            }), 128))
                                          ])
                                        ]),
                                        _: 1
                                      })
                                    ]))
                                  : (!historyLoading.value)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_38, [
                                        _createVNode(_component_v_icon, {
                                          size: "80",
                                          color: "grey-400",
                                          class: "mb-4"
                                        }, {
                                          default: _withCtx(() => [
                                            _createTextVNode("mdi-history")
                                          ]),
                                          _: 1
                                        }),
                                        _hoisted_39
                                      ]))
                                    : (_openBlock(), _createElementBlock("div", _hoisted_40, [
                                        _createVNode(_component_v_progress_circular, {
                                          indeterminate: "",
                                          color: "primary",
                                          class: "mb-4"
                                        }),
                                        _hoisted_41
                                      ])),
                                (historyInfo.value && historyInfo.value.total_count && historyInfo.value.total_count > 0)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_42, [
                                      _createVNode(_component_v_row, { align: "center" }, {
                                        default: _withCtx(() => [
                                          _createVNode(_component_v_col, null, {
                                            default: _withCtx(() => [
                                              _createElementVNode("div", _hoisted_43, [
                                                _createTextVNode(" 현재 페이지: " + _toDisplayString(historyInfo.value.current_page || 1) + "페이지 (" + _toDisplayString(historyInfo.value.total_count) + "건 조회됨) ", 1),
                                                (historyInfo.value.next_yn === 'Y')
                                                  ? (_openBlock(), _createElementBlock("span", _hoisted_44, "다음 페이지 있음"))
                                                  : _createCommentVNode("", true)
                                              ])
                                            ]),
                                            _: 1
                                          }),
                                          _createVNode(_component_v_col, { cols: "auto" }, {
                                            default: _withCtx(() => [
                                              _createVNode(_component_v_btn_group, { density: "compact" }, {
                                                default: _withCtx(() => [
                                                  _createVNode(_component_v_btn, {
                                                    disabled: (historyInfo.value.current_page || 1) <= 1,
                                                    onClick: _cache[14] || (_cache[14] = ($event: any) => (changePage((historyInfo.value.current_page || 1) - 1))),
                                                    size: "small"
                                                  }, {
                                                    default: _withCtx(() => [
                                                      _createVNode(_component_v_icon, null, {
                                                        default: _withCtx(() => [
                                                          _createTextVNode("mdi-chevron-left")
                                                        ]),
                                                        _: 1
                                                      })
                                                    ]),
                                                    _: 1
                                                  }, 8, ["disabled"]),
                                                  _createVNode(_component_v_btn, {
                                                    disabled: historyInfo.value.next_yn !== 'Y',
                                                    onClick: _cache[15] || (_cache[15] = ($event: any) => (changePage((historyInfo.value.current_page || 1) + 1))),
                                                    size: "small"
                                                  }, {
                                                    default: _withCtx(() => [
                                                      _createVNode(_component_v_icon, null, {
                                                        default: _withCtx(() => [
                                                          _createTextVNode("mdi-chevron-right")
                                                        ]),
                                                        _: 1
                                                      })
                                                    ]),
                                                    _: 1
                                                  }, 8, ["disabled"])
                                                ]),
                                                _: 1
                                              })
                                            ]),
                                            _: 1
                                          })
                                        ]),
                                        _: 1
                                      })
                                    ]))
                                  : _createCommentVNode("", true)
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_v_window_item, { value: "remain" }, {
                      default: _withCtx(() => [
                        _createVNode(_component_v_card, { elevation: "2" }, {
                          default: _withCtx(() => [
                            _createVNode(_component_v_card_title, { class: "bg-primary text-white d-flex justify-space-between align-center" }, {
                              default: _withCtx(() => [
                                _createElementVNode("div", _hoisted_45, [
                                  _createVNode(_component_v_icon, { class: "mr-2" }, {
                                    default: _withCtx(() => [
                                      _createTextVNode("mdi-counter")
                                    ]),
                                    _: 1
                                  }),
                                  _createTextVNode(" 발송가능건수 ")
                                ]),
                                _createVNode(_component_v_btn, {
                                  class: "btnColorSuccess",
                                  onClick: getSmsRemain,
                                  loading: remainLoading.value
                                }, {
                                  default: _withCtx(() => [
                                    _createVNode(_component_v_icon, { class: "mr-1" }, {
                                      default: _withCtx(() => [
                                        _createTextVNode("mdi-refresh")
                                      ]),
                                      _: 1
                                    }),
                                    _createTextVNode(" 새로고침 ")
                                  ]),
                                  _: 1
                                }, 8, ["loading"])
                              ]),
                              _: 1
                            }),
                            _createVNode(_component_v_card_text, { class: "pa-6" }, {
                              default: _withCtx(() => [
                                (remainLoading.value)
                                  ? (_openBlock(), _createElementBlock("div", _hoisted_46, [
                                      _createVNode(_component_v_progress_circular, {
                                        indeterminate: "",
                                        color: "primary",
                                        class: "mb-4"
                                      }),
                                      _hoisted_47
                                    ]))
                                  : (remainInfo.value)
                                    ? (_openBlock(), _createElementBlock("div", _hoisted_48, [
                                        _createVNode(_component_v_row, null, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_v_col, {
                                              cols: "12",
                                              md: "4"
                                            }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_v_card, {
                                                  class: "remain-card sms-card",
                                                  elevation: "4"
                                                }, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_v_card_text, { class: "text-center pa-6" }, {
                                                      default: _withCtx(() => [
                                                        _createVNode(_component_v_icon, {
                                                          color: "primary",
                                                          size: "60",
                                                          class: "mb-4"
                                                        }, {
                                                          default: _withCtx(() => [
                                                            _createTextVNode("mdi-message-text")
                                                          ]),
                                                          _: 1
                                                        }),
                                                        _createElementVNode("h3", _hoisted_49, _toDisplayString(remainInfo.value.SMS_CNT || 0), 1),
                                                        _hoisted_50
                                                      ]),
                                                      _: 1
                                                    })
                                                  ]),
                                                  _: 1
                                                })
                                              ]),
                                              _: 1
                                            }),
                                            _createVNode(_component_v_col, {
                                              cols: "12",
                                              md: "4"
                                            }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_v_card, {
                                                  class: "remain-card lms-card",
                                                  elevation: "4"
                                                }, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_v_card_text, { class: "text-center pa-6" }, {
                                                      default: _withCtx(() => [
                                                        _createVNode(_component_v_icon, {
                                                          color: "secondary",
                                                          size: "60",
                                                          class: "mb-4"
                                                        }, {
                                                          default: _withCtx(() => [
                                                            _createTextVNode("mdi-message-text-outline")
                                                          ]),
                                                          _: 1
                                                        }),
                                                        _createElementVNode("h3", _hoisted_51, _toDisplayString(remainInfo.value.LMS_CNT || 0), 1),
                                                        _hoisted_52
                                                      ]),
                                                      _: 1
                                                    })
                                                  ]),
                                                  _: 1
                                                })
                                              ]),
                                              _: 1
                                            }),
                                            _createVNode(_component_v_col, {
                                              cols: "12",
                                              md: "4"
                                            }, {
                                              default: _withCtx(() => [
                                                _createVNode(_component_v_card, {
                                                  class: "remain-card mms-card",
                                                  elevation: "4"
                                                }, {
                                                  default: _withCtx(() => [
                                                    _createVNode(_component_v_card_text, { class: "text-center pa-6" }, {
                                                      default: _withCtx(() => [
                                                        _createVNode(_component_v_icon, {
                                                          color: "info",
                                                          size: "60",
                                                          class: "mb-4"
                                                        }, {
                                                          default: _withCtx(() => [
                                                            _createTextVNode("mdi-image-text")
                                                          ]),
                                                          _: 1
                                                        }),
                                                        _createElementVNode("h3", _hoisted_53, _toDisplayString(remainInfo.value.MMS_CNT || 0), 1),
                                                        _hoisted_54
                                                      ]),
                                                      _: 1
                                                    })
                                                  ]),
                                                  _: 1
                                                })
                                              ]),
                                              _: 1
                                            })
                                          ]),
                                          _: 1
                                        })
                                      ]))
                                    : (_openBlock(), _createElementBlock("div", _hoisted_55, [
                                        _createVNode(_component_v_icon, {
                                          size: "80",
                                          color: "grey-400",
                                          class: "mb-4"
                                        }, {
                                          default: _withCtx(() => [
                                            _createTextVNode("mdi-counter")
                                          ]),
                                          _: 1
                                        }),
                                        _hoisted_56,
                                        _createVNode(_component_v_btn, {
                                          class: "btnColorPrimary mt-4",
                                          onClick: getSmsRemain
                                        }, {
                                          default: _withCtx(() => [
                                            _createVNode(_component_v_icon, { class: "mr-2" }, {
                                              default: _withCtx(() => [
                                                _createTextVNode("mdi-refresh")
                                              ]),
                                              _: 1
                                            }),
                                            _createTextVNode(" 다시 조회 ")
                                          ]),
                                          _: 1
                                        })
                                      ]))
                              ]),
                              _: 1
                            })
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                }, 8, ["modelValue"])
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["modelValue"])
  ]))
}
}

})